import {Link} from "react-router-dom";
import {SMELT_CONTRACT} from "@/lib/config";
import {explorerAddressUrl} from "@/lib/chain";

export function Footer() {
  return (
    <footer className="border-t border-forge-border bg-forge-void">
      <div className="mx-auto max-w-[1440px] px-6 py-6 flex flex-col md:flex-row items-start md:items-center gap-3 justify-between">
        <div className="flex items-center gap-2 text-xs text-forge-ash font-mono">
          <img src="/src/assets/logo.svg" alt="Smelt" className="h-5 w-auto opacity-80" />
          <span>sovereign onchain data refinery · Ritual Chain</span>
        </div>
        <div className="flex items-center gap-4 text-xs text-forge-ash">
          <Link to="/" className="hover:text-molten-300">Overview</Link>
          <Link to="/filings" className="hover:text-molten-300">Filings</Link>
          <Link to="/console" className="hover:text-molten-300">Console</Link>
          {SMELT_CONTRACT !== "0x0000000000000000000000000000000000000000" && (
            <a
              href={explorerAddressUrl(SMELT_CONTRACT)}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-molten-300"
            >
              contract ↗
            </a>
          )}
        </div>
      </div>
    </footer>
  );
}
